const EUR = (v) => (Number(v) || 0).toLocaleString("pt-PT", { style: "currency", currency: "EUR" });

function PaymentRow({ payment }) {
  const isNegative = Number(payment.ValorPago) < 0;
  const valueColor = isNegative ? "text-red-600" : "text-[#0F1829]";
  return (
    <tr className="border-b border-[#F3F0E7] last:border-0">
      <td className="px-3 py-1.5 font-mono text-[#6B7280] whitespace-nowrap">{payment.Data}</td>
      <td className={`px-3 py-1.5 font-mono text-right whitespace-nowrap ${valueColor}`}>
        {EUR(payment.ValorPago)}
      </td>
      <td className="px-3 py-1.5 text-[#6B7280] whitespace-nowrap">{payment.TipoPagamento || "—"}</td>
      <td className="px-3 py-1.5 text-[#6B7280] truncate max-w-[16rem]" title={payment.Observacoes}>
        {payment.Observacoes || ""}
      </td>
    </tr>
  );
}

export default function PaymentHistory({ payments, limit = 10 }) {
  if (!payments?.length) return null;
  return (
    <div className="border border-[#E6E1D6] rounded overflow-hidden">
      <div className="px-3 py-2 bg-[#F5F2EB] border-b border-[#E6E1D6] text-[10px] uppercase tracking-[0.15em] text-[#978D78] font-bold">
        Últimos pagamentos registados
      </div>
      <div className="max-h-40 overflow-y-auto">
        <table className="text-xs w-full">
          <tbody>
            {payments.slice(0, limit).map((p) => <PaymentRow key={p.ID_ComissaoPagamento} payment={p} />)}
          </tbody>
        </table>
      </div>
    </div>
  );
}
